module.exports = __webpack_public_path__ + "img/kobelco_logo.9a1e6ae6.png";